module.exports = __webpack_public_path__ + "assets/img/open.367ab0bf.svg";